const CUSTOMER_ID_LS_KEY = "cId";

export function getCustIdFromLS() {
    try {
        if (typeof window === "undefined") return "";
        const ls = window.localStorage;
        if (!ls || typeof ls.getItem !== "function") return "";
        return ls.getItem(CUSTOMER_ID_LS_KEY) || "";
    } catch {
        /* ignore */
    }
    return "";
}